var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-3 alert-success",attrs:{"data-test-id":"success"}},_vm._l((_vm.storeSuccess),function(item,i){return _c('SuccessItem',{key:i,attrs:{"item":item,"index":i,"data-test-id":_vm.$tid('success', `store-success-${i}`)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }